import { useState } from "react";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Pencil, Check, X } from "lucide-react";

export function SectionCard({ title, icon: Icon, section, canEdit, onSave, children, renderEdit, testid }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(null);
  const [busy, setBusy] = useState(false);
  const editable = !!canEdit;

  const start = () => { setDraft(renderEdit ? renderEdit.initial() : {}); setEditing(true); };
  const save = async () => {
    setBusy(true);
    try {
      await onSave(draft);
      setEditing(false);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <Card className="border-slate-200 shadow-sm" data-testid={testid}>
      <div className="flex items-center justify-between px-5 py-3.5 border-b border-slate-100">
        <div className="flex items-center gap-2">
          {Icon && <Icon size={17} className="text-slate-400" />}
          <h3 className="font-head font-bold tracking-tight">{title}</h3>
        </div>
        {editable && !editing && (
          <button onClick={start} className="flex items-center gap-1 text-xs font-medium text-blue-600 hover:text-blue-700 transition-colors" data-testid={`edit-${section}-button`}>
            <Pencil size={13} /> Editar
          </button>
        )}
        {editing && (
          <div className="flex gap-1">
            <Button size="sm" variant="ghost" className="h-7 px-2 text-slate-500" onClick={() => setEditing(false)}><X size={14} /></Button>
            <Button size="sm" className="h-7 px-3" onClick={save} disabled={busy} data-testid={`save-${section}-button`}><Check size={14} className="mr-1" /> Guardar</Button>
          </div>
        )}
      </div>
      <div className="p-5">
        {editing && renderEdit ? renderEdit.form(draft, setDraft) : children}
      </div>
    </Card>
  );
}

export function Field({ label, value, mono }) {
  return (
    <div>
      <div className="text-xs text-slate-400 uppercase tracking-wide">{label}</div>
      <div className={`text-sm text-slate-800 mt-0.5 ${mono ? "font-mono" : ""}`}>{value || "—"}</div>
    </div>
  );
}
